import { render } from "./LogoutUser.vue?vue&type=template&id=c6e9c09e"
import script from "./LogoutUser.vue?vue&type=script&lang=js"
export * from "./LogoutUser.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__